import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ScanResult from "@/components/ScanResult";
import Icon from "@/components/Icon";

export default function PublicLanding() {
  const { publicId } = useParams();
  const [sp] = useSearchParams();
  const table = sp.get("t") || sp.get("table") || "";
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.get(`/public/qr/${publicId}?track=${sp.get("s") ? "false" : "true"}`).then(({ data }) => setState({ loading: false, data }))
      .catch(() => setState({ loading: false, error: true }));
  }, [publicId]);

  if (state.loading) return <div className="min-h-screen grid place-items-center bg-neutral-100 dark:bg-neutral-900"><Icon name="Loader2" className="h-8 w-8 animate-spin text-primary" /></div>;
  if (state.error) return <div className="min-h-screen grid place-items-center bg-neutral-100 dark:bg-neutral-900 p-6 text-center"><div><Icon name="QrCode" className="h-10 w-10 mx-auto text-muted-foreground" /><p className="mt-3 font-semibold">QR code not found</p></div></div>;
  const { data } = state;
  if (data.status !== "active") return <div className="min-h-screen grid place-items-center bg-neutral-100 dark:bg-neutral-900 p-6 text-center"><div><Icon name="PauseCircle" className="h-10 w-10 mx-auto text-amber-500" /><p className="mt-3 font-semibold">This QR code is currently unavailable</p></div></div>;

  // Restaurant menu renders edge-to-edge (its own premium mobile layout).
  if (data.destination_type === "menu") {
    return (
      <div className="min-h-screen" style={{ maxWidth: 480, margin: "0 auto" }}>
        <ScanResult type="menu" data={data.data} company={data.company} publicId={publicId} table={table} features={data.menu_features} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-100 dark:bg-neutral-900 py-6 px-4">
      <div className="max-w-md mx-auto rounded-3xl bg-background border border-border overflow-hidden shadow-xl">
        <ScanResult type={data.destination_type} data={data.data} company={data.company} publicId={publicId} table={table} />
      </div>
      <div className="text-center mt-4 text-xs text-muted-foreground flex items-center justify-center gap-1.5"><Icon name="QrCode" className="h-3.5 w-3.5" />Powered by QR Code Creator Studio</div>
    </div>
  );
}
